import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import css from './Button.styles.scss'

import { ButtonProps } from './Button.types'

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  disabled,
  type,
  variant,
  className,
}) => {
  const buttonClasses = classNames(css.button, className, {
    [css['button--primary']]: variant === 'primary',
    [css['button--secondary']]: variant === 'secondary',
    [css['button--tertiary']]: variant === 'tertiary',
  })

  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  className: PropTypes.string,
}

Button.defaultProps = {
  onClick: () => {},
  disabled: false,
  type: 'button',
  className: '',
}

export default Button
